<template>
  <b-modal
    id="modal-email"
    centered
    title="Alterar e-mail"
    title-class="font-18"
    @show="reset"
    @hidden="close"
  >
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <form id="update-email-form" v-if="!loading" @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-12">
          <b-form-group label="Novo e-mail">
            <b-form-input
              v-model="email"
              type="email"
              class="form-control form-control-sm"
              name="email"
              v-validate="'required|email'"
              :state="submit ? !errors.has('email') : null"
            />

            <b-form-invalid-feedback>
              Preencha o email corretamente.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Documento do cliente">
            <b-form-input
              v-model="document"
              type="text"
              class="form-control form-control-sm"
              name="document"
              data-vv-as="Documento do cliente"
              v-validate="'required'"
              v-mask="['####################']"
              :state="submit ? !errors.has('document') : null"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('document') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Celular">
            <b-form-input
              v-model="cellphone"
              type="text"
              class="form-control form-control-sm"
              name="cellphone"
              v-validate="'required|min:14|max:15'"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :state="submit ? !errors.has('cellphone') : null"
            ></b-form-input>
            <b-form-invalid-feedback>
              Preencha o número de celular.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel" :disabled="loading"
        >Cancelar</b-button
      >
      <b-button
        v-if="canEditEmail"
        form="update-email-form"
        type="submit"
        variant="success"
        :disabled="loading"
      >
        Confirmar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { Validator } from "vee-validate";
import ptBR from 'vee-validate/dist/locale/pt_BR'
import { validateCpfOrCnpj } from "@src/helpers/documentValidator";
import ClientService from "@services/resources/ClientService";
import { AccessLevel } from "@views/configurations/enums/accessLevel";

var service = ClientService.build();

Validator.localize('pt_BR', ptBR)

Validator.extend('cpf_cnpj', {
  getMessage: () => 'CPF/CNPJ inválido.',
  validate: value => validateCpfOrCnpj(value),
})

export default {
  data() {
    return {
      email: "",
      document: "",
      cellphone: "",
      submit: false,
      loading: false,
    };
  },
  props: {
    client_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    canEditEmail() {
      return this.$canAction("sales_change_email", AccessLevel.EDITOR);
    },
  },
  methods: {
    reset() {
      this.email = "";
      this.document = "";
      this.cellphone = "";
      this.submit = false;
      this.loading = false;
    },
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.submit = true;
      this.loading = true;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return (this.loading = false);
        }

        let data = {
          id: this.client_id,
          email: this.email,
          document: this.document,
          cellphone: this.cellphone,
        };

        service
          .update(data)
          .then((resp) => {
            this.$bvToast.toast("E-mail alterado com sucesso!", {
              title: "Sucesso",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.$bvModal.hide("modal-email");

            this.$emit("success", true);
          })
          .catch((err) => {
            console.error(err.response)

            this.$bvToast.toast('Não foi possível atualizar o e-mail.', {
              title: "Erro na atualização",
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
          })
          .finally(() => {
            this.submit = false;
            this.loading = false;
          });
      });
    },
  },
};
</script>
